import script from "./Filelist.vue?vue&type=script&lang=ts&setup=true"
export * from "./Filelist.vue?vue&type=script&lang=ts&setup=true"

import "./Filelist.vue?vue&type=style&index=0&id=69fbc3b7&scoped=true&lang=scss"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69fbc3b7"]])

export default __exports__